import { searchStockR02, refetchStockR02 } from "src/apis/stockApi";
import {
  defaultPDA1061_R01DisplayInfo,
  PDA1061_R01SearchParams,
  toPDA1061_R01DisplayInfo,
} from "src/containers/PDA/PDA1061_R01/PDA1061_R01Dto";
import usePDA1061_R01Store from "./PDA1061_R01Store";
import { useToast } from "src/hooks/useToast";

const PDA1061_R01Content = () => {
  const {
    searchParams,
    stockList,
    setStockList,
    setLoading,
    updateSearchParam,
    setDisplayInfo,
  } = usePDA1061_R01Store();
  const { showToast } = useToast();

  const handleSearch = async (scannedValue?: string) => {
    try {
      setLoading(true);

      const params: PDA1061_R01SearchParams = {};

      if (scannedValue) {
        const trimmedValue = scannedValue.trim().toUpperCase();
        params.scanValue = trimmedValue;
        updateSearchParam("scanValue", trimmedValue);
      } else if (searchParams.scanValue) {
        params.scanValue = searchParams.scanValue;
      }

      if (searchParams.logicCenter) {
        params.logicCenter = searchParams.logicCenter;
      }
      if (searchParams.warehouseCd) {
        params.warehouseCd = searchParams.warehouseCd;
      }

      const response = await searchStockR02(params);
      const data = response?.data?.data || [];
      setStockList(data);

      if (data.length > 0) {
        setDisplayInfo(toPDA1061_R01DisplayInfo(data[0]));
      } else {
        setDisplayInfo(defaultPDA1061_R01DisplayInfo);
        showToast("warning", "검색 결과가 없습니다.");
      }
    } catch (error) {
      console.error("재고 조회 실패:", error);
      setStockList([]);
      setDisplayInfo(defaultPDA1061_R01DisplayInfo);
      showToast("error", "재고 조회에 실패했습니다.");
    } finally {
      setLoading(false);
    }
  };

  const handleRefetch = async () => {
    try {
      setLoading(true);

      const params: PDA1061_R01SearchParams = {};
      if (searchParams.scanValue) params.scanValue = searchParams.scanValue;
      if (searchParams.logicCenter) params.logicCenter = searchParams.logicCenter;
      if (searchParams.warehouseCd) params.warehouseCd = searchParams.warehouseCd;

      const response = await refetchStockR02(params);
      const data = response?.data?.data || [];
      setStockList(data);

      if (data.length > 0) {
        setDisplayInfo(toPDA1061_R01DisplayInfo(data[0]));
      }
    } catch (error) {
      console.error("재조회 실패:", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    handleSearch,
    handleRefetch,
  };
};

export default PDA1061_R01Content;
